import { ecClientApi } from "../service";
import ApiRoutes from "../constants/api-routes";

export const createCategory = async (body) => {
  try {
    const response = await ecClientApi.post(ApiRoutes.CREATE_CATEGORY, body);
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const createSubCategory = async (body, categoryId) => {
  try {
    const response = await ecClientApi.post(
      ApiRoutes.CREATE_SUB_CATEGORY + `${categoryId}`,
      body,
    );
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const getAllCategory = async (body) => {
  try {
    const response = await ecClientApi.get(ApiRoutes.GET_ALL_CATEGORY, body);
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const updateCategory = async (body, categoryId) => {
  try {
    const response = await ecClientApi.put(
      ApiRoutes.UPDATE_CATEGORY + `${categoryId}`,
      body,
    );
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const response = await ecClientApi.delete(
      ApiRoutes.DELETE_CATEGORY + `${categoryId}`,
    );
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};

export const deleteSubCategory = async (categoryId, subcategoryId) => {
  try {
    const response = await ecClientApi.delete(
      ApiRoutes.DELETE_SUB_CATEGORY + `${categoryId}/${subcategoryId}`,
    );
    return response;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};
